export enum ActionTypes {
    FETCH_AVAILABLE_BRANDS = 'FETCH_AVAILABLE_BRANDS',
}
